import type { CutSticker } from './stickers';

/**
 * How the rewards of «Магазин нагород» look (the catalog and the prices are in @shkola/core).
 * Gradients stay where the design allows them: the sky of the greeting and the ring of the animal.
 */
export const REWARD_SKIES: Record<string, string> = {
  'sky-dawn': 'linear-gradient(115deg, #fff8ef 0%, #ffe8d2 38%, #ffd0b0 72%, #ffb995 100%)',
  'sky-mint': 'linear-gradient(115deg, #f3fff9 0%, #daf7ea 38%, #b2ecd4 72%, #86dcc0 100%)',
  'sky-lavender': 'linear-gradient(115deg, #faf6ff 0%, #ebe1fd 38%, #d3c0f8 72%, #b49cef 100%)',
  'sky-sunset': 'linear-gradient(115deg, #fff3e8 0%, #ffd6bd 34%, #f7b0c0 68%, #cfa3ec 100%)',
  'sky-aurora': 'linear-gradient(115deg, #f1fdff 0%, #d4f3ff 34%, #c9e4ff 62%, #ddcdff 100%)',
};

/** The ring around the animal: a colour or a gradient. */
export const REWARD_FRAMES: Record<string, string> = {
  'frame-mint': '#7FDCC0',
  'frame-coral': '#FF8A7A',
  'frame-sky': '#7FB2FF',
  'frame-gold': 'linear-gradient(135deg, #FFE38F 0%, #F5B731 100%)',
  'frame-rainbow':
    'linear-gradient(135deg, #FF8A7A 0%, #F5C242 25%, #7FDCC0 50%, #7FB2FF 75%, #C99AE8 100%)',
};

/** The buddy next to the animal. */
export const REWARD_BUDDIES: Record<string, CutSticker> = {
  'buddy-seedling': 'seedling',
  'buddy-music': 'musical-notes',
  'buddy-ball': 'soccer-ball',
  'buddy-palette': 'artist-palette',
  'buddy-rocket': 'rocket',
  'buddy-rainbow': 'rainbow',
  'buddy-atom': 'atom-symbol',
  'buddy-telescope': 'telescope',
  'buddy-sunglasses': 'smiling-face-with-sunglasses',
  'buddy-crown': 'crown',
};
